module.exports = __webpack_public_path__ + "static/img/15.e1e5eb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/15.png
// module id = 8rMb
// module chunks = 0